import { useFormikContext } from 'formik';
import { Card, CardContent } from 'shared-components';
import { Checkbox } from 'shared-components';
import { Label } from 'shared-components';
import { FormGroup } from 'shared-components';
import { IProduct } from '@topshots/core-models';
import styles from './product-page-content.module.css';
import { FormLayout } from 'shared-components';
import { Input } from 'shared-components';
import { TextArea } from 'shared-components';

export const ProductPageContent = () => {
  const { values, getFieldProps } = useFormikContext<IProduct>();
  return (
    <Card className={styles.productPageContentCard}>
      <CardContent>
        <Label htmlFor="">Page Content</Label>
        <FormLayout>
          <FormGroup>
            <Checkbox
              label={'Has a content page'}
              type={'checkbox'}
              {...getFieldProps('content.hasContentPage')}
            ></Checkbox>
          </FormGroup>
          {values.content.hasContentPage && (
            <>
              <FormGroup>
                <Label htmlFor="content">Content</Label>
                <TextArea {...getFieldProps('content.content')} id="content" />
              </FormGroup>
              <FormGroup>
                <Checkbox
                  label={'Appears in nav'}
                  type={'checkbox'}
                  {...getFieldProps('content.appearsInNav')}
                ></Checkbox>
              </FormGroup>
              {values.content.appearsInNav && (
                <>
                  <FormGroup>
                    <Label htmlFor="navTitle">Nav Title</Label>
                    <Input
                      {...getFieldProps('content.navTitle')}
                      type="text"
                      id="navTitle"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label htmlFor="slug">Slug</Label>
                    <Input
                      {...getFieldProps('content.slug')}
                      type="text"
                      id="slug"
                    />
                  </FormGroup>
                </>
              )}
            </>
          )}
        </FormLayout>
      </CardContent>
    </Card>
  );
};
